import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["turboFrame"]
  connect() {
    this.placeholderHtml =this.turboFrameTarget.innerHTML
  }

  showModal() {
    this.element.showModal()
  }

  handleClose() {
    this.turboFrameTarget.src = ""
    this.turboFrameTarget.innerHTML = this.placeholderHtml
  }
}